import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Gift, Zap, Crown } from 'lucide-react';
import { cn } from '@/lib/cn';

export function Credits() {
  const { t } = useTranslation();
  const packs = [
    {
      key: 'pack1',
      Icon: Gift,
      featured: false,
      title: t('credits.pack1_title'),
      price: t('credits.pack1_price'),
      credits: t('credits.pack1_credits'),
      badge: undefined,
    },
    {
      key: 'pack2',
      Icon: Zap,
      featured: true,
      title: t('credits.pack2_title'),
      price: t('credits.pack2_price'),
      credits: t('credits.pack2_credits'),
      badge: t('credits.pack2_badge'),
    },
    {
      key: 'pack3',
      Icon: Crown,
      featured: false,
      title: t('credits.pack3_title'),
      price: t('credits.pack3_price'),
      credits: t('credits.pack3_credits'),
      badge: t('credits.pack3_badge'),
    },
  ];

  return (
    <section className="section bg-kquest-900/40">
      <div className="container-narrow">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-pixel text-4xl sm:text-5xl font-bold tracking-tight">
            {t('credits.title')}
          </h2>
          <p className="mt-4 text-kquest-300 text-lg">{t('credits.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {packs.map((p, i) => (
            <motion.div
              key={p.key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={cn(
                'relative p-8 flex flex-col items-center text-center',
                p.featured ? 'block-gold border-2 shadow-gold-glow' : 'block enchant-card'
              )}
            >
              {p.badge && (
                <span className={cn(
                  'absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 text-[10px] font-press uppercase tracking-wide border-2',
                  p.featured ? 'bg-kquest-950 text-gold-300 border-gold-500' : 'bg-gold-500 text-kquest-950 border-gold-700'
                )}>
                  {p.badge}
                </span>
              )}
              <p.Icon className={cn('w-10 h-10 mb-4', p.featured ? 'text-kquest-950' : 'text-kquest-200')} strokeWidth={1.6} />
              <h3 className={cn(
                'font-pixel text-xl font-semibold uppercase tracking-wide',
                p.featured ? 'text-kquest-950' : 'text-kquest-100'
              )}>
                {p.title}
              </h3>
              <div className={cn(
                'mt-4 font-press text-4xl',
                p.featured ? 'text-kquest-950' : 'text-gradient-enchant'
              )}>
                {p.price}
              </div>
              <div className={cn(
                'mt-2 text-sm font-pixel',
                p.featured ? 'text-kquest-900' : 'text-kquest-300'
              )}>
                {p.credits}
              </div>
              <button className={cn(
                'mt-8 w-full',
                p.featured ? 'btn-purple' : 'btn-gold'
              )}>
                {t('credits.buy')}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
